export default __webpack_public_path__ + "static/media/front.0d7c3e3c.jpg";